import * as React from 'react';

import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { ApiMultiSelectSearch } from '../../multiselect/ApiMultiSelectSearch';
import {
  defaultMultiSelectGetLabel,
  defaultMultiSelectRenderItem,
} from '../../multiselect/MultiSelectSearch';
import Field from '../Field';
import { FieldRenderProps } from 'react-final-form';
import { Text } from '../../typography/Text';
import { FilterInputButton } from '../../button/FilterInputButton';
import { Classes } from '../../index';
import { isMobile } from '../../common/utils';
import classNames from 'classnames';
import { DATA_FORM_INPUT } from '../../common/data';
import { ElementOf, tuple } from '../../common/props';

export const ApiMultiSelectModes = tuple('input', 'inline');
export type ApiMultiSelectMode = ElementOf<typeof ApiMultiSelectModes>;

export type ApiMultiSelectProps = Omit<
  VFFieldProps<React.ComponentProps<typeof ApiMultiSelectSearch>>,
  'value'
> & {
  /**
   * Jak se má komponenta chovat - jako klasický input s popupem nebo jako inline prvek - tedy obsah popup. Výchozí hodnota je 'input'.
   */
  mode?: ApiMultiSelectMode;
};
export const ApiMultiSelect = React.forwardRef<
  HTMLInputElement,
  ApiMultiSelectProps
>(
  (
    {
      name,
      getLabel = defaultMultiSelectGetLabel,
      renderItem = defaultMultiSelectRenderItem,
      validate,
      className,
      inputClassName,
      contentClassName,
      inlineValidation,
      label,
      required,
      disabled,
      searchItems,
      validateWarning,
      mode = 'input',
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<any[]>) => {
            if (mode === 'input') {
              let titleArr: string[] = [];
              // let tooltipArr: any[] = [];
              value &&
                value.forEach((v) => {
                  titleArr.push(getLabel(v));
                  // tooltipArr.push(<ListItem>{renderItem(v)}</ListItem>);
                });

              let info: React.ReactNode = '-';
              if (!value || value.length === 0) {
                info = (
                  <Text intent={'inactive'} italic>
                    Nevybráno
                  </Text>
                );
              } else if (value.length === 1) {
                info = titleArr[0];
              } else {
                info = `${titleArr[0]} +${value.length - 1}`;
              }

              return (
                <FilterInputButton
                  {...DATA_FORM_INPUT(name)}
                  tooltip={
                    titleArr.length > 0 ? (
                      titleArr.join(', ')
                    ) : (
                      <Text intent={'inactive'} italic>
                        Nevybráno
                      </Text>
                    )
                  }
                  className={Classes.FORM_MULTI_SELECT}
                  disabled={disabled || meta.submitting}
                  popupProps={{
                    mode: 'edit',
                    closeOnInnerClick: false,
                    arrow: true,
                    focusContentOnOpen: true,
                    position: isMobile
                      ? [
                          'bottom left',
                          'top left',
                          'bottom center',
                          'top center',
                        ]
                      : undefined,
                  }}
                  menu={(closePopup) => (
                    <ApiMultiSelectSearch
                      closePopup={closePopup}
                      className={classNames(
                        inputClassName,
                        Classes.FORM_MULTI_LIST
                      )}
                      value={value}
                      // @ts-ignore
                      ref={ref}
                      {...nother}
                      {...other}
                      renderItem={renderItem}
                      onChange={(ids) => {
                        onChange({ target: { name, value: ids } });
                      }}
                      title={label}
                      searchItems={searchItems}
                    />
                  )}
                >
                  {info}
                </FilterInputButton>
              );
            } else {
              return (
                <ApiMultiSelectSearch
                  className={classNames(
                    inputClassName,
                    Classes.FORM_MULTI_LIST,
                    Classes.FORM_MULTI_LIST_INLINE
                  )}
                  disabled={disabled || meta.submitting}
                  noAutoFocus
                  hideCloseButton
                  value={value}
                  // @ts-ignore
                  ref={ref}
                  {...nother}
                  {...other}
                  renderItem={renderItem}
                  onChange={(ids) => {
                    onChange({ target: { name, value: ids } });
                  }}
                  searchItems={searchItems}
                />
              );
            }
          }}
        </Field>
      </FormItem>
    );
  }
);
